
export class FastFormulaAreasItems
{
    static GameGrid = "gamegrid";
    static GameData = "gameData";
    static BracketDefs = "bracket-defs";
    static BracketInfo = "bracket-info";
    static RulesData = "rulesData";
    static GlobalNames = "workbookNamesItems";
}
